import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';

export { AdapterDateFns };
export default AdapterDateFns;
